import { ContentBg, enhancedFetch, Form, ssrBuilder, SubmitButton, TextInput } from 'journey-ui'
import { GetServerSidePropsContext } from 'next'
import React, { useState } from 'react'
import { AppPage } from '../components/AppPage'
import { redirectIfNoBrand } from '../helpers'

interface LoginPageForm {
  email: string
  password: string
}

interface Props {
  brand: Brand
}

const ForgotPasswordPage: React.FC<Props> = ({ brand }) => {
  const [success, setSuccess] = useState<string>('')

  const [form, setForm] = useState<LoginPageForm>({
    email: '',
    password: '',
  })

  const submitForm = async () => {
    const resp = await enhancedFetch<{ status: string }>('/api/auth/forgot-password', {
      method: 'POST',
      body: form,
    })

    setSuccess(resp.status)
  }

  return (
    <AppPage brand={brand} title="Forgot Password" description="Reset your password by providing your email address.">
      <div className="flex items-center justify-center min-h-full">
        <Form className="bg-white w-96 h-64 p-4 flex-grow-0 rounded justify-center items-center space-y-2 z-20" value={form} onChange={setForm}>
          {success ? <div className="text-lg mt-2">{success}</div> : (
            <>
              <span className="text-center">
                If you can't remember your password, please provide your email address and we will send you
                a link which you may use to change your password.
              </span>
              <TextInput name="email" type="email" />
              <SubmitButton color="primary" className="w-full justify-center h-10 font-bold" onClick={submitForm}>
                Send Reset Link
              </SubmitButton>
            </>
          )}
        </Form>
      </div>
      <ContentBg src="https://pizzamico8-dev.s3.amazonaws.com/branding/pizza-man-cover.png" />
    </AppPage>
  )
}

// noinspection JSUnusedGlobalSymbols (PHPStorm doesn't detect NextJS's pages)
export default ForgotPasswordPage

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  return ssrBuilder(ctx)
    .setProp('brand', (fetcher) => fetcher(`/api/brand/${ctx.req.headers.host}`))
    .onError(redirectIfNoBrand)
    .get()
}
